import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { ROUTES } from '@/shared/config';
import { ErrorBoundary, ProtectedRoute } from '@/shared/ui';
import { logger } from '@/shared/lib';

// Layout
import { MainLayout } from '@/app/layouts/MainLayout';

// Pages
import { DashboardPage } from '@/pages/dashboard';
import { PhoneboardDetailPage } from '@/pages/phoneboard-detail';
import { PhoneboardManagementPage } from '@/pages/phoneboard-management';
import { AccountManagementPage } from '@/pages/account-management';
import { SnsAccountManagementPage } from '@/pages/sns-account-management';
import { TaskManagementPage } from '@/pages/task-management';
import { TaskHistoryPage } from '@/pages/task-history';
import { NotificationsPage } from '@/pages/notifications';
import { NotFoundPage } from '@/pages/not-found';
import { TestErrorPage } from '@/pages/test-error';
import { LoginPage } from '@/pages/LoginPage';

const router = createBrowserRouter([
  {
    path: ROUTES.LOGIN,
    element: <LoginPage />,
  },
  {
    path: ROUTES.ROOT,
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={ROUTES.DASHBOARD} replace />,
      },
      {
        path: ROUTES.DASHBOARD,
        element: <DashboardPage />,
      },
      {
        path: ROUTES.PHONEBOARDS,
        element: <PhoneboardManagementPage />,
      },
      {
        path: ROUTES.PHONEBOARD_DETAIL,
        element: <PhoneboardDetailPage />,
      },
      {
        path: ROUTES.ACCOUNTS,
        element: <AccountManagementPage />,
      },
      {
        path: ROUTES.SNS_ACCOUNTS,
        element: <SnsAccountManagementPage />,
      },
      {
        path: ROUTES.TASKS,
        element: <TaskManagementPage />,
      },
      {
        path: ROUTES.TASK_HISTORY,
        element: <TaskHistoryPage />,
      },
      {
        path: ROUTES.NOTIFICATIONS,
        element: <NotificationsPage />,
      },
      // ErrorBoundary 테스트 경로들
      {
        path: '/tasks/execution',
        element: <TestErrorPage />,
      },
      {
        path: '/test-error',
        element: <TestErrorPage />,
      },
    ],
    // 404 에러 처리
    errorElement: <NotFoundPage />,
  },
  // 모든 다른 경로에 대한 fallback
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);

export const AppRouter: React.FC = () => {
  return (
    <ErrorBoundary
      showDetails={import.meta.env.DEV}
      onError={(error, errorInfo) => {
        logger.error('Router Error:', error);
        logger.error('Router Error Info:', errorInfo);
      }}
    >
      <RouterProvider router={router} />
    </ErrorBoundary>
  );
};